import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, formValueSelector} from 'redux-form';

import Label from 'components/Label';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import Money from 'components/Money';

import {TextField, DateField} from 'components/Fields';

import {validDate} from 'utils/validators';
import {formatDateForApi, formatDate} from 'utils/datetime';
import {initiateGocardlessPayment} from 'ducks/tenancy';

import './styles.css';

const TAKE_PAYMENT_AS_SOON_AS_POSSIBLE = 'As soon as possible';
const TAKE_PAYMENT_ON_SPECIFIC_DATE = 'Specific date';

const formSubmit = (values, dispatch, props) => {
  const {invoiceId, getExtraActions} = props;
  const {description, takePayment, specifiedChargeDate} = values;
  let data = {invoiceId, description};

  if (takePayment === TAKE_PAYMENT_ON_SPECIFIC_DATE) {
    data['specifiedChargeDate'] = formatDateForApi(specifiedChargeDate);
  }

  dispatch(initiateGocardlessPayment(data, getExtraActions()));
};

class InitiateGoCardlessPaymentForm extends React.Component<any> {
  render() {
    const {error, amount, nextPossibleChargeDate, takePayment} = this.props;
    const takePaymentAsap = takePayment === TAKE_PAYMENT_AS_SOON_AS_POSSIBLE;

    return (
      <form className="InitiateGoCardlessPaymentForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <Label>Amount</Label>
        <Money amount={amount} className="invoiceAmount" />
        <FormField className="paymentDescription">
          <Label>Description</Label>
          <Field
            name="description"
            component={TextField}
            validate={[]}
            placeholder="invoice description here"
          />
        </FormField>
        <div className="takePaymentContainer">
          <FormField>
            <Field
              name="takePayment"
              component="input"
              type="radio"
              value={TAKE_PAYMENT_AS_SOON_AS_POSSIBLE}
            />
            <Label>
              {'Take payment as soon as possible (' +
                formatDate(nextPossibleChargeDate) +
                ')'}
            </Label>
          </FormField>
          <FormField>
            <Field
              name="takePayment"
              component="input"
              type="radio"
              value={TAKE_PAYMENT_ON_SPECIFIC_DATE}
            />
            <Label>Take payment on a specific date</Label>
          </FormField>
          {!takePaymentAsap && (
            <FormField className="specifyChargeDate">
              <Field
                name="specifiedChargeDate"
                validate={[validDate]}
                component={DateField}
                dayPickerProps={{
                  disabledDays: {before: new Date(nextPossibleChargeDate)}
                }}
              />
            </FormField>
          )}
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state, props) => {
  const {description, amount, invoice} = props;
  const formSelector = formValueSelector('initiateGoCardlessPaymentForm');

  let paymentDescription = description;

  if (invoice.rentStart && invoice.rentEnd) {
    paymentDescription = `Licence fee for ${formatDate(
      invoice.rentStart
    )} - ${formatDate(invoice.rentEnd)}`;
  }

  return {
    initialValues: {
      description: paymentDescription,
      takePayment: TAKE_PAYMENT_AS_SOON_AS_POSSIBLE
    },
    amount,
    takePayment: formSelector(state, 'takePayment')
  };
};

const initiateGoCardlessPaymentForm = reduxForm({
  form: 'initiateGoCardlessPaymentForm',
  onSubmit: formSubmit,
  enableReinitialize: true
})(InitiateGoCardlessPaymentForm);

export default connect(mapStateToProps)(initiateGoCardlessPaymentForm);
